<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Table of Contents</p>
<p class="P_TOC_Entry_1"><a href="#/section0002#auto_bookmark_table_of_contents_1">Blurb</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#auto_bookmark_table_of_contents_1">Chapter 1</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004#auto_bookmark_table_of_contents_1">Chapter 2</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005#auto_bookmark_table_of_contents_1">Chapter 3</a></p>
<p class="P_TOC_Entry_1"><span href="#/section0006#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 4</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0007#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 5</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0008#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 6</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0009#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 7</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0010#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 8</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0011#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 9</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0012#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 10</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0013#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 11</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0014#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 12</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0015#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 13</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0016#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 14</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0017#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 15</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0018#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapter 16</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0019#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Epilogue</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0020#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Keep reading for an excerpt</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0022#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">More from Andrew Grey</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0023#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Readers love Andrew Grey</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0024#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">About the Author</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0025#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">By Andrew Grey</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0026" title="Link target outside of Sample">Visit Dreamspinner Press</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0027#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?2020a242